export default __webpack_public_path__ + "media/plus/plus-level-up-4fba472d.jpg";